import { createContext } from "react";

export const UserTokenContext = createContext<string>(
  JSON.parse(
    localStorage.getItem("amoozeshMeliToken") || JSON.stringify("init")
  )
);
